// import { useState, useRef, useEffect } from 'react';
// import HeaderOther from '../../ui/header-other';
// import ProductInfoCard from '../../ui/productInfoCard';
// import { aiSearch } from '../../services/ai-service';
// import './ai.css';

// const samplePrompts = [
//   'Show me healthy grocery picks for the week',
//   'Find dairy-free snacks near me',
//   'What is the fastest delivery option?',
// ];

// const startingMessages = [
//   {
//     sender: 'assistant',
//     text: 'Could you tell me whether you are looking for healthy snacks, breakfast items, or groceries?',
//   },
// ];

// const defaultLocation = {
//   lat: 23.980339245364284,
//   lng: 85.35999799535229,
// };

// export default function AiAssistant() {
//   const [query, setQuery] = useState('');
//   const [messages, setMessages] = useState(startingMessages);
//   const [location, setLocation] = useState(defaultLocation);
//   const [resultText, setResultText] = useState('');
//   const [aiItems, setAiItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const chatWindowRef = useRef(null);

//   useEffect(() => {
//     if (!chatWindowRef.current) return;
//     chatWindowRef.current.scrollTo({
//       top: chatWindowRef.current.scrollHeight,
//       behavior: 'smooth',
//     });
//   }, [messages, aiItems, loading]);

//   const fillPrompt = (prompt) => {
//     setQuery(prompt);
//     setError('');
//   };

//   const getBrowserLocation = () => {
//     if (!navigator.geolocation) {
//       setError('Geolocation is not supported by your browser.');
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         setLocation({
//           lat: position.coords.latitude,
//           lng: position.coords.longitude,
//         });
//         setError('');
//       },
//       () => {
//         setError('Unable to access location. Please allow location access and try again.');
//       }
//     );
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!query.trim()) return;

//     const userMessage = {
//       sender: 'user',
//       text: query.trim(),
//     };

//     const assistantPending = {
//       sender: 'assistant',
//       text: 'Let me fetch the best grocery recommendations for you.',
//     };

//     setMessages((prev) => [...prev, userMessage, assistantPending]);
//     setLoading(true);
//     setError('');
//     setResultText('');
//     setAiItems([]);

//     const queryContent = [
//       ...messages
//         .filter((message) => message.text !== assistantPending.text)
//         .map((message) => ({
//           role: message.sender === 'assistant' ? 'assistant' : 'user',
//           content: message.text,
//         })),
//       { role: 'user', content: query.trim() },
//     ];

//     try {
//       const response = await aiSearch({ queryContent, location });
//       const aiResponse = response?.aiResponse || {};

//       console.log('Received AI response:', aiResponse);
//       const items = Array.isArray(aiResponse.items) ? aiResponse.items : [];

//       const clarificationValue = aiResponse?.clarification_required;
//       const isClarificationRequired =
//         clarificationValue === true ||
//         clarificationValue === 'true' ||
//         clarificationValue === 'True' ||
//         clarificationValue === 'TRUE';

//       let assistantReply;
//       if (isClarificationRequired) {
//         setResultText(aiResponse?.clarification_question || 'I need a bit more information to provide the best suggestions. Could you please clarify?');
//         assistantReply = {
//           sender: 'assistant',
//           text: aiResponse?.clarification_question || 'I need a bit more information to provide the best suggestions. Could you please clarify?',
//         };
//       } else {
//         setResultText(aiResponse?.short_description || 'Here are the AI suggestions based on your request.');
//         setAiItems(items);
//         assistantReply = {
//           sender: 'assistant',
//           text: aiResponse?.short_description || 'I found some smart grocery options for you.',
//         };
//       }

//       setMessages((prev) => [...prev.slice(0, -1), assistantReply]);
//       setQuery('');
//     } catch (fetchError) {
//       setError(fetchError.message || 'Unable to fetch AI results.');
//       setMessages((prev) => [...prev.slice(0, -1), {
//         sender: 'assistant',
//         text: 'I could not get a response from FresloAI right now. Please try again.',
//       }]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getItemCardData = (item) => {
//     const products = Array.isArray(item.topMatches)
//       ? item.topMatches.map((match) => match.product || match)
//       : item.product
//       ? [item.product]
//       : [];

//     return products.map((product) => ({
//       id: product?.id || '',
//       data: product || {},
//     }));
//   };

//   return (
//     <div className="ai-assistant-page">
//       <HeaderOther title="FresloAI" description="active" />

//       <div className="ai-chat-window" ref={chatWindowRef}>
//         {messages.map((message, index) => (
//           <div
//             key={`${message.sender}-${index}`}
//             className={`ai-chat-message ${message.sender === 'assistant' ? 'assistant-message' : 'user-message'}`}
//           >
//             <span className="ai-chat-badge">{message.sender === 'assistant' ? 'FresloAI' : 'You'}</span>
//             <p>{message.text}</p>
//           </div>
//         ))}

//         {(loading || error || resultText || aiItems.length > 0) && (
//           <div className="ai-response-section">
//             {loading && <div className="ai-loading">Loading suggestions…</div>}
//             {error && <div className="ai-error-message">{error}</div>}
//             {/* {resultText && <p className="ai-response-summary"><strong>{resultText}</strong></p>} */}

//             {aiItems.length > 0 ? (
//               <div className="ai-item-list">
//                 {aiItems.map((item, index) => {
//                   const itemCardData = getItemCardData(item);
//                   return (
//                     <div key={`ai-item-${index}`} className="ai-item-row">
//                       <div className="ai-item-meta">
//                         <span className="ai-item-term">{item.search_term}</span>
//                         <span className="ai-item-category">{item.category}</span>
//                       </div>
//                       <p className="ai-item-reason">{item.reason}</p>

//                       {itemCardData.length > 0 && (
//                         <div className="ai-product-card-row">
//                           <ProductInfoCard dataList={itemCardData} />
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             ) : (
//               !loading && !error && !resultText && (
//                 <div className="ai-empty-state">
//                   Ask FresloAI a query to see grocery suggestions and matching products.
//                 </div>
//               )
//             )}
//           </div>
//         )}
//       </div>

//       <form className={`ai-input-area${loading ? ' loading' : ''}`} onSubmit={handleSubmit}>
//         <input
//           id="ai-search"
//           className="ai-search-input"
//           type="text"
//           value={query}
//           onChange={(event) => setQuery(event.target.value)}
//           placeholder="Ask FresloAI about grocery suggestions, delivery, or offers..."
//           autoComplete="off"
//         />
//         <button type="submit" className="ai-search-button" disabled={loading}>
//           <span className="ai-search-button-label">{loading ? 'Sending' : 'Ask'}</span>
//           <span className="ai-search-button-icon" aria-hidden="true">➤</span>
//         </button>
//       </form>
//     </div>
//   );
// }

import { useState, useRef, useEffect, useContext } from "react";
import HeaderOther from "../../ui/header-other";
import ProductInfoCard from "../../ui/productInfoCard";
import { aiSearch } from "../../services/ai-service";
import "./ai.css";
import { cartContext } from "../../../App";
import { Link } from "react-router-dom";

const samplePrompts = [
    "Show healthy groceries",
    "Fresh vegetables under ₹300",
    "Protein rich breakfast",
    "Today's best offers",
];

const startingMessages = [
    {
        sender: "assistant",
        text: "Hi 👋 I'm Freslo AI. Ask me anything about groceries, recipes, brands or delivery.",
    },
];

const defaultLocation = {
    lat: 23.980339245364284,
    lng: 85.35999799535229,
};

export default function AiAssistant() {
    const [query, setQuery] = useState("");
    const [messages, setMessages] = useState(startingMessages);

    const [location, setLocation] = useState(defaultLocation);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const [resultText, setResultText] = useState("");

    const [aiItems, setAiItems] = useState([]);

    const { CartItem, extraData } = useContext(cartContext);

    const orderValue = CartItem.reduce(
        (sum, item) => sum + Math.round(item.details.price) * item.qty,
        0,
    );
    const [cartGlow, setCartGlow] = useState(false);

    const freeDeliveryUnlocked = orderValue >= extraData.data.minOrderValueFee;

    const chatWindowRef = useRef(null);
    const bottomRef = useRef(null);

    useEffect(() => {
        if (CartItem.length === 0) return;

        setCartGlow(true);

        const timer = setTimeout(() => {
            setCartGlow(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, [CartItem]);

    useEffect(() => {
        const timer = setTimeout(() => {
            bottomRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "end",
            });
        }, 50);

        return () => clearTimeout(timer);
    }, [messages, aiItems, loading]);

    const fillPrompt = (prompt) => {
        setQuery(prompt);
        setError("");
    };

    const getBrowserLocation = () => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
                setError("");
            },
            () => {
                setError(
                    "Unable to access location. Please allow location access and try again.",
                );
            },
        );
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!query.trim()) return;

        const userMessage = {
            sender: "user",
            text: query.trim(),
        };

        const assistantPending = {
            sender: "assistant",
            text: "Let me fetch the best grocery recommendations for you.",
        };

        setMessages((prev) => [...prev, userMessage, assistantPending]);
        setLoading(true);
        setError("");
        setResultText("");
        setAiItems([]);

        const queryContent = [
            ...messages
                .filter((message) => message.text !== assistantPending.text)
                .map((message) => ({
                    role: message.sender === "assistant" ? "assistant" : "user",
                    content: message.text,
                })),
            { role: "user", content: query.trim() },
        ];

        try {
            const response = await aiSearch({ queryContent, location });
            const aiResponse = response?.aiResponse || {};

            console.log("Received AI response:", aiResponse);
            const items = Array.isArray(aiResponse.items)
                ? aiResponse.items
                : [];

            const clarificationValue = aiResponse?.clarification_required;
            const isClarificationRequired =
                clarificationValue === true ||
                clarificationValue === "true" ||
                clarificationValue === "True" ||
                clarificationValue === "TRUE";

            let assistantReply;
            if (isClarificationRequired) {
                setResultText(
                    aiResponse?.clarification_question ||
                        "I need a bit more information to provide the best suggestions. Could you please clarify?",
                );
                assistantReply = {
                    sender: "assistant",
                    text:
                        aiResponse?.clarification_question ||
                        "I need a bit more information to provide the best suggestions. Could you please clarify?",
                };
            } else {
                setResultText(
                    aiResponse?.short_description ||
                        "Here are the AI suggestions based on your request.",
                );
                setAiItems(items);
                assistantReply = {
                    sender: "assistant",
                    text:
                        aiResponse?.short_description ||
                        "I found some smart grocery options for you.",
                };
            }

            setMessages((prev) => [...prev.slice(0, -1), assistantReply]);
            setQuery("");
        } catch (fetchError) {
            setError(fetchError.message || "Unable to fetch AI results.");
            setMessages((prev) => [
                ...prev.slice(0, -1),
                {
                    sender: "assistant",
                    text: "I could not get a response from FresloAI right now. Please try again.",
                },
            ]);
        } finally {
            setLoading(false);
        }
    };

    const getItemCardData = (item) => {
        const products = Array.isArray(item.topMatches)
            ? item.topMatches.map((match) => match.product || match)
            : item.product
              ? [item.product]
              : [];

        return products.map((product) => ({
            id: product?.id || "",
            data: product || {},
        }));
    };

    return (
        <div className="ai-page">
            {/* Animated Background */}

            <div className="ai-background">
                <div className="ai-background-blob ai-background-blob-blue"></div>

                <div className="ai-background-blob ai-background-blob-purple"></div>

                <div className="ai-background-blob ai-background-blob-cyan"></div>

                <div className="ai-background-grid"></div>
            </div>

            <HeaderOther title="Freslo AI" description="Active" />

            {/* Hero */}

            <section className="ai-hero">
                <div className="ai-hero-orb">
                    <span className="ai-hero-orb-core"></span>

                    <span className="ai-hero-orb-ring ai-hero-orb-ring-1"></span>

                    <span className="ai-hero-orb-ring ai-hero-orb-ring-2"></span>

                    <span className="ai-hero-orb-ring ai-hero-orb-ring-3"></span>
                </div>

                <h1 className="ai-hero-title">Ask Freslo AI</h1>

                <p className="ai-hero-subtitle">
                    Discover groceries, compare products, find healthier
                    alternatives and get smart shopping recommendations.
                </p>

                <div className="ai-suggestion-container">
                    {samplePrompts.map((item) => (
                        <button
                            key={item}
                            className="ai-suggestion-chip"
                            onClick={() => fillPrompt(item)}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </section>

            {/* Chat */}

            <section className="ai-chat-container" ref={chatWindowRef}>
                {messages.map((message, index) => (
                    <div
                        key={`${message.sender}-${index}`}
                        className={`ai-message ${
                            message.sender === "assistant"
                                ? "ai-message-assistant"
                                : "ai-message-user"
                        }`}
                    >
                        {message.sender === "assistant" && (
                            <div className="ai-message-avatar">
                                <div className="ai-message-avatar-core"></div>
                            </div>
                        )}

                        <div className="ai-message-content">
                            <div className="ai-message-label">
                                {message.sender === "assistant"
                                    ? "Freslo AI"
                                    : "You"}
                            </div>

                            <div className="ai-message-text">
                                {message.text}
                            </div>
                        </div>
                    </div>
                ))}

                {(loading || error || resultText || aiItems.length > 0) && (
                    <div className="ai-response-wrapper">
                        {loading && (
                            <div className="ai-thinking">
                                <div className="ai-thinking-orb"></div>

                                <div className="ai-thinking-content">
                                    <div className="ai-thinking-title">
                                        Freslo AI is thinking...
                                    </div>

                                    <div className="ai-thinking-subtitle">
                                        Searching products & comparing
                                        recommendations
                                    </div>
                                </div>
                            </div>
                        )}

                        {error && <div className="ai-error-card">{error}</div>}

                        {loading && (
                            <div className="ai-thinking">
                                <div className="ai-thinking-animation">
                                    <span className="ai-thinking-dot"></span>
                                    <span className="ai-thinking-dot"></span>
                                    <span className="ai-thinking-dot"></span>
                                </div>

                                <div className="ai-thinking-content">
                                    <div className="ai-thinking-title">
                                        Freslo AI is thinking...
                                    </div>

                                    <div className="ai-thinking-subtitle">
                                        Searching nearby products, comparing
                                        brands and checking offers.
                                    </div>
                                </div>
                            </div>
                        )}

                        {error && (
                            <div className="ai-error-card">
                                <div className="ai-error-icon">⚠️</div>

                                <div className="ai-error-text">{error}</div>
                            </div>
                        )}

                        {!loading && !error && resultText && (
                            <div className="ai-result-summary">
                                <div className="ai-result-summary-icon">✨</div>

                                <div className="ai-result-summary-text">
                                    {resultText}
                                </div>
                            </div>
                        )}

                        {!loading && !error && aiItems.length > 0 && (
                            <div className="ai-result-list">
                                {aiItems.map((item, index) => {
                                    const itemCardData = getItemCardData(item);

                                    return (
                                        <div
                                            key={`item-${index}`}
                                            className="ai-result-card"
                                        >
                                            <div className="ai-result-card-header">
                                                <div>
                                                    <div className="ai-result-title">
                                                        {item.search_term}
                                                    </div>

                                                    <div className="ai-result-category">
                                                        {item.category}
                                                    </div>
                                                </div>

                                                <div className="ai-result-number">
                                                    {index + 1}
                                                </div>
                                            </div>

                                            <div className="ai-result-reason">
                                                {item.reason}
                                            </div>

                                            {itemCardData.length > 0 && (
                                                <div className="ai-product-scroll">
                                                    <ProductInfoCard
                                                        dataList={itemCardData}
                                                    />
                                                </div>
                                            )}

                                            <div className="ai-follow-up">
                                                <button
                                                    type="button"
                                                    className="ai-follow-up-chip"
                                                    onClick={() =>
                                                        setQuery(
                                                            `Show cheaper alternatives for ${item.search_term}`,
                                                        )
                                                    }
                                                >
                                                    Cheaper
                                                </button>

                                                <button
                                                    type="button"
                                                    className="ai-follow-up-chip"
                                                    onClick={() =>
                                                        setQuery(
                                                            `Show healthier alternatives for ${item.search_term}`,
                                                        )
                                                    }
                                                >
                                                    Healthier
                                                </button>

                                                <button
                                                    type="button"
                                                    className="ai-follow-up-chip"
                                                    onClick={() =>
                                                        setQuery(
                                                            `Compare brands for ${item.search_term}`,
                                                        )
                                                    }
                                                >
                                                    Compare
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {!loading &&
                            !error &&
                            !resultText &&
                            aiItems.length === 0 && (
                                <div className="ai-empty-state">
                                    <div className="ai-empty-icon">✨</div>

                                    <div className="ai-empty-title">
                                        What would you like to shop today?
                                    </div>

                                    <div className="ai-empty-subtitle">
                                        Ask naturally like "healthy breakfast",
                                        "protein snacks", "vegetables under
                                        ₹300", or "best rice for biryani"
                                    </div>
                                </div>
                            )}
                    </div>
                )}
                <div ref={bottomRef} className="ai-scroll-anchor"></div>
            </section>

            {/* Floating Composer */}

            <form
                className={`ai-composer ${
                    loading ? "ai-composer-loading" : ""
                }`}
                onSubmit={handleSubmit}
            >
                <div className="ai-composer-inner">
                    <Link
                        to="/cart"
                        className={`ai-cart-shortcut
                            ${CartItem.length > 0 ? "ai-cart-shortcut-active" : ""}
                            ${cartGlow ? "ai-cart-shortcut-glow" : ""}
                        `}
                    >
                        <span className="ai-cart-shortcut-icon">🛒</span>

                        {CartItem.length > 0 ? (
                            <>
                                <span className="ai-cart-shortcut-count">
                                    {CartItem.length}
                                </span>

                                <span className="ai-cart-shortcut-divider">
                                    •
                                </span>

                                <span className="ai-cart-shortcut-price">
                                    ₹{orderValue}
                                </span>

                                {freeDeliveryUnlocked && (
                                    <span className="ai-cart-free"></span>
                                )}
                            </>
                        ) : (
                            <span className="ai-cart-shortcut-empty">Cart</span>
                        )}
                    </Link>

                    <input
                        id="ai-search"
                        className="ai-composer-input"
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Ask Freslo AI anything..."
                        autoComplete="off"
                        autoFocus
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();

                                handleSubmit(e);
                            }
                        }}
                    />

                    <button
                        type="submit"
                        className="ai-composer-send"
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="ai-send-spinner"></span>
                        ) : (
                            "➜"
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}
